import moment from 'moment';


export const formatDate = date => moment(date).format('HH:MM, D MMM YYYY');



// WEBPACK FOOTER //
// ./src/modals/tasks-modal/task-form/helpers.js